export const birthTypes: ReactSelectOption[] = [
	{ value: 1, label: "Humanizado" },
	{ value: 2, label: "Cesárea" },
	{ value: 3, label: "Normal" },
];
